module.exports = __webpack_public_path__ + "img/icon-ai-similar.29ac9f78.svg";